import {
  Edit,
  Map,
  BarChart2,
  Key,
  HelpCircle,
  Star,
  Bell,
  Clock,
  Edit2,
} from 'react-feather'

const defaultUserPermissions = [
  'edits',
  'posts',
  'infos',
  'insights',
  'keywords',
  'questions',
  'reviews',
  'notifications',
  'schedules',
]

const defaultUserPermissionIcons = {
  insights: BarChart2,
  keywords: Key,
  questions: HelpCircle,
  posts: Edit,
  reviews: Star,
  infos: Map,
  notifications: Bell,
  schedules: Clock,
  edits: Edit2,
}

const defaultUserNotifications = ['monthlyReport']

Object.freeze(defaultUserPermissions)
Object.freeze(defaultUserPermissionIcons)
Object.freeze(defaultUserNotifications)

export {
  defaultUserNotifications,
  defaultUserPermissions,
  defaultUserPermissionIcons,
}
